module.exports = __webpack_public_path__ + "static/media/icon_change.b691f975.svg";